import React, { useState, useEffect, useRef } from 'react';

// import { nanoid } from 'nanoid';

const { detect } = require('detect-browser');
const browser = detect();

interface SVGElementInterface extends Element {
  beginElement(): SVGElement;
}

type AnimatedImagesProps = {
  href?: string;
  orientation?: string;
  id?: string;
  body?: string;
  isDesktopOrLaptop?: any;
};

export const AnimatedImages: React.FC<AnimatedImagesProps> = ({ ...props }) => {
  const { href, orientation, id, body, isDesktopOrLaptop } = props;
  const [active, setActive] = useState(false);
  const [enter, setEnter] = useState(false);

  const linkHover = useRef<SVGElementInterface & SVGElement>(null);
  const linkDefault = useRef<SVGElementInterface & SVGElement>(null);

  const path = {
    default: 'M 12.174323,-0.32037691 393.10247,13.135453 402.71378,255.3404 0,272 Z',
    inverse: 'M -0.37108656,15.585635 402.62891,0.37108656 390.01197,270.89319 8.1639042,259.01842 Z'
  };

  useEffect(() => {
    if (body || !isDesktopOrLaptop) return;
    const id = setTimeout(() => {
      setActive(!active);
    }, 10000);
    if (active) {
      linkHover.current?.beginElement();
    } else {
      linkDefault.current?.beginElement();
    }
    return () => clearTimeout(id);

  }, [active]);

  useEffect(() => {
    if (!body) setActive(true);
  }, []);

  const mouseEnter = () => setEnter(true);

  const mouseLeave = () => setEnter(false);

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];
  
  return (
  <div
    onMouseEnter={mouseEnter}
    onMouseLeave={mouseLeave}
    className={`
      ${body? `overflow-hidden cursor-pointer` : ``}
      relative
      left-2/4
      lg:left-0
      transform
      -translate-x-2/4
      lg:transform-none
      lg:translate-x-0
      ${body? `` : `ml-6`}
      lg:ml-0
      inline-flex
    `}
  >
    <svg
      preserveAspectRatio="xMidYMin slice"
      width="403"
      height="272"
      viewBox="0 0 403 272"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask id={`maskLink${id}`} maskUnits="userSpaceOnUse" x="0" y="0" width="403" height="272">

        <path
          d={orientation ? path.inverse : path.default}
          fill="#FFFFFF"
        >

          <animate
            ref={linkHover}
            id="link-hover"
            begin="indefinite"
            fill="freeze"
            attributeName="d"
            dur={`1500ms`}
            to={orientation ? path.default : path.inverse}
          />
          <animate
            ref={linkDefault}
            id="link-default"
            begin="indefinite"
            fill="freeze"
            attributeName="d"
            dur={`1500ms`}
            to={orientation ? path.inverse : path.default}
          />

        </path>

      </mask>


      <g mask={`url(#maskLink${id})`}>
        <rect
          className={`
            transform
            transition-all
            ease-linear
            duration-1500
            ${active ? `translate-x-2` : `-translate-x-2`}
          `}
          x="-12"
          y="-8"
          width="426"
          height="287"
          fill={enter && body ? `#65A3FF` : `url(#patternLink${id})`}
        />
      </g>

      <defs>
        <pattern
          id={`patternLink${id}`}
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref={`#imageLink${id}`} transform="translate(-0.102981) scale(0.00133996 0.00197628)" />
        </pattern>
        <image
          id={`imageLink${id}`}
          width="900"
          height="506"
          xlinkHref={href}
        />
      </defs>


    </svg>
    {body &&
      <div
        className={`
          ${enter ? `animate-opacity` : ``}

          transform
          opacity-0
          translate-y-full

          indent-sm
          font-medium
          text-black
          text-xxs
          italic

          pl-18
          pr-18

          lg:pl-10
          lg:pr-10
          
          flex
          items-center

          absolute
          top-0
          left-0
          h-full
          z-1
        `}
        dangerouslySetInnerHTML={{ __html: body }}
      />
    }
  </div>
  );
}